/* Soulskart cart coupon sheet — behaviour.
   Markup: sections/ss-coupon.liquid. Skin: assets/ss-coupon.css.

   ONE COUPON, ONE ROW.
   The previous version kept a separate applied-coupons list at the top of the
   sheet AND flipped the matching card to "Applied", so SAVE10 appeared twice
   with two different controls. That list is gone. A coupon has exactly one row;
   applying it turns that row's own action into Remove, which is the only thing
   the duplicate list offered.

   Applied coupons are also moved to the top of the list, so the sheet reads
   what-you-have then what-you-could-have without a second container.

   NO APPLY BUTTON ON A COUPON YOU CANNOT APPLY. THIS IS THE POINT.
   There are two ways a coupon can be out of reach and they were handled
   inconsistently:

     server-side  logged-in-only or tag-gated. Liquid knows at render time and
                  prints a lock chip instead of a button. Always was correct.
     client-side  minimum spend or minimum item count. Only the cart knows, so
                  Liquid cannot decide. The first pass printed the Apply button
                  regardless and merely swallowed the click — which is the exact
                  fault the redesign set out to remove, left in place for half
                  the cases. The strongest colour on the screen still sat on a
                  control that did nothing.

   swapAction() below now treats both the same way: below the minimum, the
   button is hidden and the same lock chip takes its place, with the progress
   bar underneath explaining the gap. Cross the threshold and the button comes
   back on the next repaint, without a reload.

   THE GATE IS A PROGRESS BAR, NOT A SCOLD.
   Unmet minimums state the exact gap: 250 more to unlock, or 3 more items.

   Amounts are read from /cart.js and formatted in whole rupees. Coupon copy is
   never passed through innerHTML — the only markup string in this file is the
   constant lock icon. */
(() => {
  if (window.__ssCoupon) return;
  window.__ssCoupon = true;

  const LOCK_SVG =
    '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true">' +
    '<rect x="5" y="11" width="14" height="9" rx="2" stroke="currentColor" stroke-width="1.8"/>' +
    '<path d="M8 11V8a4 4 0 0 1 8 0v3" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>';

  const modal = () => document.getElementById('ss-coupon-modal');
  const tpl = () => document.querySelector('[data-ss-coupon-trigger-tpl]');
  const fmtINR = (cents) => '₹' + Math.round((cents || 0) / 100).toLocaleString('en-IN');

  const appliedCodes = () =>
    Array.from(document.querySelectorAll('.cart-discount__pill[data-discount-code]'))
      .map((p) => (p.getAttribute('data-discount-code') || '').trim())
      .filter(Boolean);

  const removeApplied = (code) => {
    const lc = code.toLowerCase();
    const pill = Array.from(document.querySelectorAll('.cart-discount__pill[data-discount-code]'))
      .find((p) => (p.getAttribute('data-discount-code') || '').trim().toLowerCase() === lc);
    if (!pill) return;
    const btn = pill.querySelector('.cart-discount__pill-remove') || pill;
    btn.click();
  };

  const applyCode = (code) => {
    code = (code || '').trim();
    if (!code) return;
    const disc = document.querySelector('cart-discount-component');
    const input = disc && disc.querySelector('input[name=discount]');
    const form = disc && disc.querySelector('form');
    if (input && form) {
      input.value = code;
      if (typeof form.requestSubmit === 'function') form.requestSubmit();
      else form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    } else {
      window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=/cart';
    }
  };

  /* ---------------- cart snapshot --------------------------------------- */
  let cart = { total: 0, count: 0, amounts: {} };

  const readCart = async () => {
    try {
      const c = await (await fetch('/cart.js', { headers: { Accept: 'application/json' } })).json();
      const amounts = {};
      (c.cart_level_discount_applications || []).forEach((d) => {
        const t = (d.title || d.code || '').toLowerCase();
        if (t) amounts[t] = d.total_allocated_amount;
      });
      cart = { total: c.total_price || 0, count: c.item_count || 0, amounts: amounts };
    } catch (e) {}
    return cart;
  };

  /* ---------------- the action swap ------------------------------------- */
  /* One place decides what control a card shows, so a coupon can never offer
     an Apply it would refuse. Chip is created on demand and removed again, so
     no CSS is needed to hide it. */
  const chipFor = (act) => {
    let chip = act.querySelector('[data-skcp-chip]');
    if (chip) return chip;
    chip = document.createElement('span');
    chip.className = 'skcp__lockchip';
    chip.setAttribute('data-skcp-chip', '');
    chip.innerHTML = LOCK_SVG;
    chip.appendChild(document.createTextNode('Locked'));
    act.appendChild(chip);
    return chip;
  };

  const swapAction = (card, state, code) => {
    const act = card.querySelector('.skcp__act');
    if (!act) return;
    const btn = act.querySelector('.skcp__btn');
    const existing = act.querySelector('[data-skcp-chip]');

    if (state === 'short') {
      if (btn) {
        btn.hidden = true;
        btn.setAttribute('aria-hidden', 'true');
        btn.tabIndex = -1;
      }
      chipFor(act);
      return;
    }

    if (existing) existing.remove();
    if (!btn) return;
    btn.hidden = false;
    btn.removeAttribute('aria-hidden');
    btn.tabIndex = 0;

    if (state === 'applied') {
      btn.textContent = 'Remove';
      btn.setAttribute('data-ss-coupon-remove', code);
      btn.removeAttribute('data-ss-coupon-apply');
    } else {
      btn.textContent = btn.getAttribute('data-apply-label') || 'Apply';
      btn.setAttribute('data-ss-coupon-apply', code);
      btn.removeAttribute('data-ss-coupon-remove');
    }
  };

  /* ---------------- render ---------------------------------------------- */
  let lastSig = null;

  const paint = async (force) => {
    const m = modal();
    const codes = appliedCodes();
    const sig = codes.join('|').toLowerCase();
    if (!force && sig === lastSig) return;
    lastSig = sig;
    const lc = codes.map((c) => c.toLowerCase());

    document.querySelectorAll('[data-ss-coupon-badge]').forEach((b) => {
      if (codes.length) {
        b.textContent = codes.length === 1 ? codes[0] : codes.length + ' applied';
        b.hidden = false;
      } else {
        b.textContent = '';
        b.hidden = true;
      }
    });

    if (!m) return;
    await readCart();

    /* Savings bar. Sums every applied cart-level discount. */
    const bar = m.querySelector('[data-ss-coupon-savings]');
    const amt = m.querySelector('[data-ss-coupon-savings-amt]');
    let saved = 0;
    lc.forEach((c) => { saved += cart.amounts[c] || 0; });
    if (bar && amt) {
      if (saved > 0) { amt.textContent = fmtINR(saved); bar.hidden = false; }
      else { bar.hidden = true; }
    }

    const list = m.querySelector('[data-ss-coupon-list]');
    const cards = m.querySelectorAll('.skcp');

    cards.forEach((card) => {
      const code = (card.getAttribute('data-code') || '').trim();
      const on = lc.indexOf(code.toLowerCase()) !== -1;
      const locked = card.getAttribute('data-locked') === '1';
      const gate = card.querySelector('[data-skcp-gate]');

      card.classList.toggle('is-applied', on);

      /* Server-locked cards never had a button to begin with. */
      if (locked) { if (gate) gate.hidden = true; return; }

      /* Work out the gap first — the control depends on it. */
      const min = parseInt(card.getAttribute('data-min') || '0', 10) || 0;
      const minQty = parseInt(card.getAttribute('data-min-qty') || '0', 10) || 0;
      let pct = 100;
      let msg = '';

      if (!on) {
        if (min > 0 && cart.total < min) {
          pct = Math.max(4, Math.round((cart.total / min) * 100));
          msg = 'Add ' + fmtINR(min - cart.total) + ' more to unlock';
        } else if (minQty > 0 && cart.count < minQty) {
          const left = minQty - cart.count;
          pct = Math.max(4, Math.round((cart.count / minQty) * 100));
          msg = 'Add ' + left + (left === 1 ? ' more item' : ' more items') + ' to unlock';
        }
      }

      const short = msg !== '';
      card.classList.toggle('is-short', short);
      swapAction(card, on ? 'applied' : short ? 'short' : 'open', code);

      if (gate) {
        if (short) {
          const fill = gate.querySelector('[data-skcp-bar]');
          const text = gate.querySelector('[data-skcp-gate-text]');
          if (fill) fill.style.width = pct + '%';
          if (text) text.textContent = msg;
          gate.hidden = false;
        } else {
          gate.hidden = true;
        }
      }
    });

    /* Applied first. Keeps the sheet readable without a second container. */
    if (list) {
      Array.from(cards)
        .filter((c) => c.classList.contains('is-applied'))
        .reverse()
        .forEach((c) => list.insertBefore(c, list.firstChild));
    }
  };

  /* ---------------- apply feedback -------------------------------------- */
  const syncApplyBtn = () => {
    const m = modal();
    if (!m) return;
    const inp = m.querySelector('.ss-coupon-input');
    const btn = m.querySelector('.skcp-entry__apply');
    if (inp && btn) btn.disabled = !inp.value.trim();
  };

  const reflectAfterApply = (code) => {
    const m = modal();
    const err = m && m.querySelector('[data-ss-coupon-err]');
    if (err) err.hidden = true;
    const lc = code.trim().toLowerCase();
    let tries = 0;
    const check = () => {
      tries += 1;
      if (appliedCodes().map((c) => c.toLowerCase()).indexOf(lc) !== -1) {
        paint(true);
        const inp = m && m.querySelector('.ss-coupon-input');
        if (inp) { inp.value = ''; syncApplyBtn(); }
        return;
      }
      if (tries >= 9) { if (err) err.hidden = false; return; }
      setTimeout(check, 200);
    };
    setTimeout(check, 250);
  };

  /* ---------------- open / close ---------------------------------------- */
  let lastFocus = null;

  const open = () => {
    const m = modal();
    if (!m) return;
    lastFocus = document.activeElement;
    const err = m.querySelector('[data-ss-coupon-err]');
    if (err) err.hidden = true;
    syncApplyBtn();
    paint(true);

    const drawer = document.querySelector('.cart-drawer__dialog');
    const r = drawer ? drawer.getBoundingClientRect() : null;
    if (r && r.width > 60 && r.height > 60) {
      Object.assign(m.style, {
        position: 'fixed', margin: '0', borderRadius: '0',
        top: r.top + 'px', left: r.left + 'px',
        width: r.width + 'px', height: r.height + 'px',
        maxWidth: 'none', maxHeight: 'none',
      });
    } else {
      Object.assign(m.style, {
        position: 'fixed', margin: '0', borderRadius: '0',
        top: '0', right: '0', left: 'auto', bottom: 'auto',
        width: 'min(460px, 96vw)', height: '100dvh',
        maxWidth: '96vw', maxHeight: '100dvh',
      });
    }
    if (typeof m.showModal === 'function' && !m.open) m.showModal();
    else m.setAttribute('open', '');
    const first = m.querySelector('.ss-coupon-input');
    if (first) setTimeout(() => first.focus(), 40);
  };

  const close = () => {
    const m = modal();
    if (!m) return;
    if (typeof m.close === 'function' && m.open) m.close();
    else m.removeAttribute('open');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  };

  /* ---------------- events ---------------------------------------------- */
  document.addEventListener('click', (e) => {
    const t = e.target;
    if (!t || !t.closest) return;

    if (t.closest('[data-ss-coupon-open]')) { e.preventDefault(); open(); return; }
    if (t.closest('[data-ss-coupon-close]')) { e.preventDefault(); close(); return; }

    const rem = t.closest('[data-ss-coupon-remove]');
    if (rem) { e.preventDefault(); removeApplied(rem.getAttribute('data-ss-coupon-remove')); return; }

    const app = t.closest('[data-ss-coupon-apply]');
    if (app) {
      e.preventDefault();
      /* Belt and braces. The button should not exist in these states. */
      if (app.closest('.skcp.is-locked') || app.closest('.skcp.is-short')) return;
      const code = app.getAttribute('data-ss-coupon-apply');
      applyCode(code);
      reflectAfterApply(code);
      return;
    }

    const m = modal();
    if (m && t === m) close();
  });

  document.addEventListener('input', (e) => {
    if (e.target && e.target.classList && e.target.classList.contains('ss-coupon-input')) syncApplyBtn();
  });

  document.addEventListener('submit', (e) => {
    if (!e.target || !e.target.matches || !e.target.matches('[data-ss-coupon-form]')) return;
    e.preventDefault();
    const inp = e.target.querySelector('.ss-coupon-input');
    const code = inp ? inp.value.trim() : '';
    if (!code) { if (inp) inp.focus(); return; }
    applyCode(code);
    reflectAfterApply(code);
  });

  /* Repaint when the cart changes underneath the sheet, so a coupon unlocks
     the moment the threshold is crossed. */
  document.addEventListener('cart:refresh', () => paint(true));
  document.addEventListener('cart:update', () => paint(true));

  /* ---------------- trigger injection ----------------------------------- */
  const injectTrigger = () => {
    const t = tpl();
    const first = t && t.content && t.content.firstElementChild;
    if (!first) return;
    document.querySelectorAll('.cart-drawer__summary .cart-actions').forEach((actions) => {
      if (actions.querySelector('.ss-coupon-trigger')) return;
      actions.insertBefore(first.cloneNode(true), actions.firstChild);
    });
  };

  const init = () => {
    let raf;
    const run = () => { try { injectTrigger(); paint(false); } catch (e) {} };
    const mo = new MutationObserver(() => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(run);
    });
    mo.observe(document.body, { childList: true, subtree: true });
    run();
    [300, 800, 1500, 2800].forEach((ms) => setTimeout(run, ms));
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
